import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Modal, Button, Table, Spinner } from "react-bootstrap";
import { savOperations } from "state/ducks/store/sav";

/**
 * Le barème en entier, consultable sans quitter la fenêtre SAV. Il est servi par
 * l'API, donc c'est bien le barème que l'outil applique — pas une copie qui
 * dérive de son côté.
 */
const BaremeModal = (props) => {
  const { show, onHide } = props;
  const dispatch = useDispatch();
  const [bareme, setBareme] = useState(null);

  useEffect(() => {
    if (!show || bareme) return;
    dispatch(savOperations.getBareme()).then(
      (res) => setBareme(res?.data?.result?.item || null),
      () => setBareme(null)
    );
  }, [show, bareme, dispatch]);

  return (
    <Modal show={show} onHide={onHide} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 20 }}>Le barème SAV</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!bareme ? (
          <div className="text-center py-4"><Spinner animation="border" variant="success" /></div>
        ) : (
          <>
            {bareme.groups.map((group) => (
              <div key={group.title} className="mb-4">
                <h6 className="mb-1" style={{ color: "#2f7a41", fontWeight: 600 }}>{group.title}</h6>
                {group.intro && <p className="text-muted mb-2" style={{ fontSize: "0.85rem" }}>{group.intro}</p>}
                <Table size="sm" bordered className="mb-0">
                  <tbody>
                    {group.rows.map((row, idx) => (
                      <tr key={idx}>
                        <td style={{ width: "42%" }}>{row.case}</td>
                        <td>
                          <b>{row.gesture}</b>
                          {row.note && <div className="text-muted" style={{ fontSize: "0.82rem" }}>{row.note}</div>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))}
            <p className="text-muted mb-0" style={{ fontSize: "0.82rem" }}>
              Source : {bareme.source}. Les montants s'entendent sur le montant payé de la
              commande, produits de négoce exclus — ils ne sont pas déduits automatiquement.
            </p>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>Fermer</Button>
      </Modal.Footer>
    </Modal>
  );
};

BaremeModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
};

export default BaremeModal;
